// @flow
export { default } from './SavesTemplate';



// WEBPACK FOOTER //
// ./src/components/saves/SavesTemplate/index.js